/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGlobalRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGlobalRemoteSessionIssuerRequest = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGlobalRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  GetGlobalRemoteSessionIssuerSecurity$Outbound,
  GetGlobalRemoteSessionIssuerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getGlobalRemoteSessionIssuerSecurityToJSON(
  getGlobalRemoteSessionIssuerSecurity: GetGlobalRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionIssuerSecurity$outboundSchema.parse(
      getGlobalRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type GetGlobalRemoteSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  GetGlobalRemoteSessionIssuerRequest$Outbound,
  GetGlobalRemoteSessionIssuerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getGlobalRemoteSessionIssuerRequestToJSON(
  getGlobalRemoteSessionIssuerRequest: GetGlobalRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionIssuerRequest$outboundSchema.parse(
      getGlobalRemoteSessionIssuerRequest,
    ),
  );
}
